// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-08T21:19:02.370Z
// Property: The Station (ID: 6767906449166795)
// Collections: 14 amenities, 3 floorplans (live), 39 photos, 40 POIs, 5 reviews, 1 virtual tours, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166795",
  "property_external_id": "cg5er9e",
  "property_zillow_url": "https://www.zillow.com/apartments/littleton-co/station/5XhvW9/",
  "property_apartments_url": "https://www.apartments.com/station-littleton-co/cg5er9e/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Station+Apartments/data=!4m2!3m1!1s0x0:0xa25e5fd58aca36b4?sa=X&ved=2ahUKEwi3_5G45qeSAxWom68BHR2zHysQ_BJ6BAg9EAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "2756511728",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "375TSN",
  "property_status": null,
  "property_slug": "station",
  "property_name": "The Station",
  "property_website_url": "https://www.stationapts.com/",
  "property_domain": "https://www.stationapts.com/",
  "property_address": "2100 West Berry Avenue",
  "property_full_address": "2100 W Berry Ave, Littleton, CO 80120",
  "property_address_1": "2100 W Berry Ave",
  "property_address_2": null,
  "property_address_city": "Littleton",
  "property_address_state": "CO",
  "property_address_zip_full": null,
  "property_address_zip": "80120",
  "property_address_country": "US",
  "property_address_county": "Arapahoe County",
  "property_neighborhood_address": "Downtown Littleton",
  "property_address_latitude": "39.6166353",
  "property_address_longitude": "-105.0133604",
  "property_email": null,
  "property_phone": "(303) 328-5280",
  "property_call_tracking_phone": "855-381-8253",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Station in Littleton, CO, our thoughtfully designed floor plans—ranging from cozy studios to spacious two-bedroom apartments—couple modern comforts with vibrant community living. Enjoy amenities like high-speed internet, air conditioning, and stylish stainless steel appliances. Your perfect home awaits—see our availability or schedule a tour today!",
  "property_long_description": "Welcome to Station, where modern living meets convenience in the heart of Littleton, CO. Our vibrant apartment community offers a variety of thoughtfully designed floor plans, including cozy studios and spacious one and two-bedroom apartments, perfect for every lifestyle. \n\nImagine coming home to a place where premium amenities enhance your daily life. Enjoy the convenience of in-unit washers and dryers, air conditioning, and high-speed internet access. Our apartments boast contemporary features such as stainless steel appliances, walk-in closets, and charming fireplaces, creating an inviting atmosphere you’ll love. Plus, each residence includes a well-equipped kitchen with a refrigerator, microwave, and dishwasher, making meal prep a breeze.\n\nStation is ideally situated within walking distance to campus, offering an unparalleled level of convenience for students and professionals alike. Our dedicated community features laundry facilities, ample storage space, and smoke-free living, ensuring a serene environment to unwind. Relax on your private balcony or patio, or take advantage of the beautiful Colorado weather.\n\nOur commitment to exceptional customer service and comfortable living spaces makes Station the perfect place to call home. Whether you're seeking a stylish studio or a spacious two-bedroom, we have the ideal apartment waiting for you. \n\nFind your new home today—browse our availability or schedule a tour to explore our welcoming community firsthand! Experience all that Station has to offer, and elevate your lifestyle in Littleton.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-ca1a-7388-8f23-022562547b23.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of apartment buildings with balconies and covered parking.",
    "public_id": "019f8070-ca1a-7388-8f23-022562547b23",
    "storage_key": "property/6767906449166795/019f8070-ca1a-7388-8f23-022562547b23.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449166795/019ffc71-c2a8-753d-94ac-fc4c5ec6f698.mp4",
  "property_featured_video_media": {
    "public_id": "019ffc71-c2a8-753d-94ac-fc4c5ec6f698",
    "storage_key": "property/6767906449166795/019ffc71-c2a8-753d-94ac-fc4c5ec6f698.mp4",
    "thumbnail_key": "property/6767906449166795/019ffc71-c2a8-753d-94ac-fc4c5ec6f698_thumb.webp",
    "size_bytes": 32745343,
    "classification": "Apartment",
    "title": "Apartment Interior and Community Overview",
    "description": "Discover comfortable living in our apartments, featuring modern kitchens and amenities. Explore the surrounding community and green spaces."
  },
  "property_total_units": "97",
  "property_year_built": "1983",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.9381443298969",
  "property_admin_fee": "200",
  "property_application_fee": "68.67",
  "property_fees_deposit_info": "$750-$1250",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Dogs and cats allowed. Maximum of 2 pets per apartment.",
  "property_pet_policy_description": "Dogs and cats allowed. $300 deposit. $35 monthly pet rent. Maximum of 2 pets per apartment.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://www.myrentalapplication.com/index/amcthestation",
  "property_resident_portal_url": "https://station.goprisma.com/auth/login",
  "property_apply_now_url": "https://myrentalapplication.com/index/amcthestation",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02cf-7783-71ff-952f-90de2d673e45.webp",
  "property_primary_logo_media": {
    "alt_text": "The Station Apartments logo with a train icon",
    "public_id": "019d02cf-7783-71ff-952f-90de2d673e45",
    "storage_key": "property/6767906449166795/019d02cf-7783-71ff-952f-90de2d673e45.webp",
    "width": 100,
    "height": 100
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02cf-7783-71ff-952f-90de2d673e45.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Station Apartments logo with a train icon",
    "public_id": "019d02cf-7783-71ff-952f-90de2d673e45",
    "storage_key": "property/6767906449166795/019d02cf-7783-71ff-952f-90de2d673e45.webp",
    "width": 100,
    "height": 100
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02cf-7783-71ff-952f-90de2d673e45.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Station Apartments logo with a train icon",
    "public_id": "019d02cf-7783-71ff-952f-90de2d673e45",
    "storage_key": "property/6767906449166795/019d02cf-7783-71ff-952f-90de2d673e45.webp",
    "width": 100,
    "height": 100
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#273239",
  "property_secondary_color": "#00BCD4",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "0",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "500 - 850",
  "property_sqft_min": "500",
  "property_sqft_max": "850",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": 2,
  "property_facebook_url": "https://www.facebook.com/stationapartmentslittleton",
  "property_instagram_url": "https://www.instagram.com/stationapartments/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJH85IWzSAbIcRtDbKitVfXqI",
  "property_youtube_url": "https://www.youtube.com/shorts/hkz1mXi5tbw?t=92",
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=Littleton%2C+CO",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Station",
  "property_home_romance_title": "Find Your Heart's Home at Our Charming Apartment Community",
  "property_home_amenities_blurb": "Welcome to Station in Littleton, CO, where comfort meets convenience! Enjoy professional management, pet-friendly living, and modern amenities like air conditioning, walk-in closets, and fully equipped kitchens. Unwind on your private balcony or cozy up by the fireplace—your ideal apartment experience awaits. Check out our community offerings today!",
  "property_home_floorplans_blurb": "Welcome to Station, where modern living meets the charm of Littleton, CO. Our thoughtfully designed floor plans cater to every lifestyle, offering spacious layouts and stylish finishes. Dive into our vibrant community and envision your next chapter—your ideal apartment home awaits just a click away!",
  "property_home_gallery_blurb": "Welcome to Station, where comfort meets convenience in vibrant Littleton, CO. Our thoughtfully designed floor plans come with modern amenities like walk-in closets, an air-conditioned oasis, and pet-friendly spaces. With a smoke-free environment and covered parking, your perfect home is just a heartbeat away. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Welcome to Station in Littleton, CO, where modern living meets vibrant community life. Enjoy easy access to cultural gems like the Littleton Museum and Highlands Ranch Mansion, or unwind at Chatfield State Park. Embrace an active lifestyle with nearby fitness centers and adventure parks, all just steps from your front door.",
  "property_home_reviews_blurb": "At Station in Littleton, CO, residents rave about the vibrant community and top-notch amenities, stating it’s “a perfect blend of comfort and convenience.” Experience the welcoming atmosphere and modern living that our residents cherish. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "Nestled in the heart of Littleton, Station offers easy access to vibrant community hotspots like Arapahoe Community College and Magness Arena. Immerse yourself in nature at Pirates Cove Water Park or enjoy a day at Chatfield State Park. Uncover the rich tapestry of local treasures that awaits. ",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Station in Littleton, CO, every detail caters to your lifestyle. Choose from stylish studios to spacious two-bedroom apartments, featuring stainless steel appliances, in-unit laundry, and private balconies. With ample storage and a smoke-free environment, comfort and convenience are at your fingertips—perfectly located just a stroll from campus!",
  "property_applynow_blurb": "At Station in Littleton, CO, enjoy a vibrant lifestyle with stylish studio, one, and two-bedroom apartments. Delight in modern amenities like air conditioning, stainless steel appliances, and spacious walk-in closets. Conveniently located near campus, find your perfect home today and lease online effortlessly for a fresh start!",
  "property_contactus_blurb": "At Station in scenic Littleton, CO, each of our thoughtfully designed floor plans—studio, one-bedroom, and two-bedroom—offers a perfect blend of comfort and style. Whether you're looking for a cozy retreat or a spacious haven, your ideal space awaits. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At Station in Littleton, CO, we offer an array of thoughtfully designed floor plans, including studio, one-bedroom, and two-bedroom options to suit your lifestyle. Dive into our FAQs page for insightful answers about our vibrant community and make your next move with confidence. Your ideal home awaits!",
  "property_floorplans_blurb": "At Station in Littleton, CO, our thoughtfully designed floor plans—studios, one-bedroom, and two-bedroom—offer the ideal backdrop for your lifestyle. Each space is tailored for comfort and functionality. Browse our available apartment homes and find the perfect match that resonates with your vision of home.",
  "property_gallery_blurb": "At Station in Littleton, CO, our stylish apartments cater to every lifestyle with options ranging from cozy studios to spacious two-bedrooms. Picture yourself enjoying convenient amenities like high-speed internet, stainless steel appliances, and private balconies. Embrace a vibrant community, just steps from campus. Your ideal home awaits!",
  "property_interactivemap_blurb": "At Station in Littleton, CO, choose from stylish studio, one, or two-bedroom layouts that perfectly complement your lifestyle. Enjoy modern amenities like stainless steel appliances, spacious walk-in closets, and high-speed internet. Ready to find your new home? Use our interactive community map to browse available apartments and pricing today!",
  "property_pets_blurb": "At Station in Littleton, CO, your furry friends are part of the family! Enjoy spacious apartments with a welcoming pet policy, just $300 for the deposit and $35 monthly rent for each pet. With room for up to two, your pets will thrive in our vibrant community!",
  "property_referafriend_blurb": "At Station in Littleton, CO, we embrace the joy of community living. Choose from our stylish studio, one-bedroom, or two-bedroom floor plans, perfect for every lifestyle. Great friends make great neighbors, so share the experience and refer a friend to join our welcoming neighborhood today!",
  "property_residentaccess_blurb": "Welcome to Station in Littleton, CO, where your ideal living space awaits! Choose from cozy studios or spacious one- and two-bedroom floor plans tailored for comfort. Stay connected with your community—access your resident portal to pay rent, request maintenance, and enjoy seamless living at Station.",
  "property_reviews_blurb": "At Station in Littleton, CO, residents celebrate their vibrant community. One happy tenant raves, \"The staff truly goes above and beyond to create a welcoming atmosphere!\" Join our thriving neighborhood and see what our residents have to say about living at our community! Your new home awaits.",
  "property_created_at": "1762201029744",
  "property_scheduletour_blurb": "At Station in Littleton, CO, our thoughtfully designed studio, one-bedroom, and two-bedroom apartments invite you to embrace modern living. Experience vibrant community life and cozy interiors that cater to your lifestyle. Curious about our exceptional atmosphere? Schedule a tour and see what our residents truly love about life here!",
  "property_thankyou_blurb": "Thank you for reaching out about Station, your future home in Littleton, CO! From cozy studios to spacious two-bedroom layouts, we have the perfect floor plan for your lifestyle. Our team will be in touch soon to help you find your ideal apartment in our vibrant community.",
  "property_virtualtours_blurb": "Welcome to Station in Littleton, CO, where modern living meets comfort. Choose from stylish studio, one-bedroom, or two-bedroom floor plans designed for your lifestyle. Experience the allure of our community from anywhere—take a virtual tour today and envision your new home filled with endless possibilities!",
  "property_copyright": "2025 All Rights Reserved. Station",
  "property_seo_title_home": "Station |  Apartments in Littleton, CO",
  "property_seo_description_home": "Discover your ideal home at Station in Littleton, CO! Thoughtful floor plans with modern amenities, just steps from campus. Join us today!",
  "property_seo_title_floorplans": "Floor Plans | Littleton, CO Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Station in Littleton, CO. Choose from stylish studios, spacious one and two-bedroom apartments. Your perfect home awaits!",
  "property_seo_title_amenities": "Amenities | Littleton, CO Apartments for Rent",
  "property_seo_description_amenities": "Experience modern living at Station in Littleton, CO. Enjoy spacious floor plans, convenient amenities, and a vibrant community just steps from campus.",
  "property_seo_title_gallery": "Gallery | Apartments in Littleton, CO",
  "property_seo_description_gallery": "Experience life at Station in Littleton, CO! Stunning studio to two-bedroom apartments with modern amenities. Picture your perfect home today!",
  "property_seo_title_virtualtours": "Virtual Tours | Station Apartments",
  "property_seo_description_virtualtours": "Step inside Station Littleton! Experience our studio, one, and two-bedroom apartments with a virtual tour. Your perfect home awaits in stunning Littleton!",
  "property_seo_title_interactivemap": "Interactive Map | Station Apartments",
  "property_seo_description_interactivemap": "Find your ideal apartment at Station in Littleton, CO! Use our interactive map to explore floor plans, amenities, and start your journey to a stylish new home.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Littleton, CO",
  "property_seo_description_neighborhood": "Discover the vibrant Littleton community around Station! Explore local favorites and hidden gems that make it the ideal place to call home.",
  "property_seo_title_contact": "Contact Us | Station",
  "property_seo_description_contact": "Connect with our leasing team at Station in Littleton, CO! Explore unique studio, one, and two-bedroom floor plans tailored for you. Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Littleton, CO",
  "property_seo_description_faqs": "Discover Station in Littleton, CO—your go-to for floor plans, amenities, and all you need for an ideal living experience!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Littleton, CO",
  "property_seo_description_reviews": "Experience the charm of Station in Littleton, CO! Check out resident reviews and see why our spacious studios and two-bedroom homes stand out.",
  "property_seo_title_applynow": "Apply Now | Apartments in Littleton, CO",
  "property_seo_description_applynow": "Discover modern living at Station in Littleton, CO! Choose from cozy studios to spacious two-bedrooms with excellent amenities. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | Station",
  "property_seo_description_residentaccess": "Join the Station community in Littleton, CO! Log in to your resident portal for easy rent payment, maintenance requests, and vital community updates today!",
  "property_seo_title_referafriend": "Refer A Friend | Station",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Station in Littleton, CO, and enjoy exclusive perks together in our vibrant community. Join us!",
  "property_seo_title_scheduletour": "Schedule a Tour | Station",
  "property_seo_description_scheduletour": "Discover modern living at Station in Littleton, CO! Schedule your tour today to explore vibrant community vibes and stunning amenities!",
  "property_seo_title_privacy": "Privacy Policy | Station",
  "property_seo_description_privacy": "Your privacy matters at Station in Littleton, CO. Dive into our comprehensive policy to see how we safeguard your information. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Station",
  "property_seo_description_accessibility": "At Station in Littleton, CO, we prioritize digital inclusion. Explore our commitment to accessibility and create a home where everyone can thrive.",
  "property_seo_title_sitemap": "Sitemap | Station",
  "property_seo_description_sitemap": "Navigate your way to your dream home at Station in Littleton, CO. Find community highlights and essential info on our sitemap to simplify your search!",
  "property_seo_title_thankyou": "Thank You | Station",
  "property_seo_description_thankyou": "Thank you for reaching out to Station in Littleton, CO! Our team will connect with you soon to help you find your perfect home. Exciting adventures await!",
  "property_seo_title_pets": "Pet Policy | Apartments in Littleton, CO",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293616786",
  "amenities": [
    {
      "id": "ec_c03b0292c6922f99a43301c8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "generator",
      "external_id": "false",
      "title": "Professional Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6abbb4b986083916849e7b37",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "generator",
      "external_id": "false",
      "title": "Great Neighborhood",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_451a0ec3f7628a8df0c8b3ac",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "generator",
      "external_id": "false",
      "title": "Laundry Facility",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_98a879d140169a5984296b99",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "generator",
      "external_id": "false",
      "title": "Covered Parking Available*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bd346cbc7821afad8d5eda17",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "generator",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aedf3da354d153996a51ab62",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "generator",
      "external_id": "false",
      "title": "High Speed Internet Available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1a2f8a95b9e3a5892d8ba65d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "generator",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0ad134b22240fa1952acbc7d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "generator",
      "external_id": "false",
      "title": "Walk In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d57b66eb01e6e9cf759e2609",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "generator",
      "external_id": "false",
      "title": "Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d1cd9a717e1cb0e0127aac55",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "generator",
      "external_id": "false",
      "title": "Washer/Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d832badab959ed06c2ed84ce",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "generator",
      "external_id": "false",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3c5d11bcc54871a99b67f874",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "generator",
      "external_id": "false",
      "title": "Fully Equipped Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_134e51aba7c85d0599d1f717",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "generator",
      "external_id": "false",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_06d8334f2e45381b7b7d9e11",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "generator",
      "external_id": "false",
      "title": "Storage Units",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_4a18bb49-36b0-442b-a617-9146cb9d344a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-f581-7633-9df2-e9df45d34c7e.webp",
      "image_media": {
        "alt_text": "The Station Apartments logo on a brick monument.",
        "public_id": "019f8070-f581-7633-9df2-e9df45d34c7e",
        "storage_key": "property/6767906449166795/019f8070-f581-7633-9df2-e9df45d34c7e.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Community",
      "description": "Welcome sign for The Station Apartments featuring the property's logo.",
      "link": "",
      "alt_text": "The Station Apartments logo on a brick monument.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ccae5992-16d7-4492-abc4-0ccc0569235c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8071-3655-73ed-b190-40173b5eb585.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with balconies and brick accents at The Station apartments in downtown Littleton, CO.",
        "public_id": "019f8071-3655-73ed-b190-40173b5eb585",
        "storage_key": "property/6767906449166795/019f8071-3655-73ed-b190-40173b5eb585.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Community",
      "description": "Exterior view of the apartment building showcasing its balconies, brickwork, and landscaping.",
      "link": "",
      "alt_text": "Exterior of apartment building with balconies and brick accents at The Station apartments in downtown Littleton, CO.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_86da08e7-49a8-494e-b330-9f3e7faf756d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8071-3594-7128-8c94-9665ac6434f5.webp",
      "image_media": {
        "alt_text": "Exterior building view with balconies and landscaping at The Station apartments in downtown Littleton, CO.",
        "public_id": "019f8071-3594-7128-8c94-9665ac6434f5",
        "storage_key": "property/6767906449166795/019f8071-3594-7128-8c94-9665ac6434f5.webp",
        "width": 3072,
        "height": 2043
      },
      "title": "Community",
      "description": "Exterior view of the apartment building, showcasing the architecture, balconies, and landscaping. Includes a sign for the leasing office.",
      "link": "",
      "alt_text": "Exterior building view with balconies and landscaping at The Station apartments in downtown Littleton, CO.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_47b82fc0-17e1-45d8-8047-ef5132a2ed9b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8071-2e9e-745a-a815-007d02cff790.webp",
      "image_media": {
        "alt_text": "The Station Apartments monument sign",
        "public_id": "019f8071-2e9e-745a-a815-007d02cff790",
        "storage_key": "property/6767906449166795/019f8071-2e9e-745a-a815-007d02cff790.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Community",
      "description": "Welcome to The Station Apartments, a vibrant community offering comfortable living.",
      "link": "",
      "alt_text": "The Station Apartments monument sign",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ae6ab09e-5fd1-4dc9-87de-292339ea1388",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8071-2e8a-725e-b098-8a5667379992.webp",
      "image_media": {
        "alt_text": "Exterior of The Station Apartments building with a monument sign and trees.",
        "public_id": "019f8071-2e8a-725e-b098-8a5667379992",
        "storage_key": "property/6767906449166795/019f8071-2e8a-725e-b098-8a5667379992.webp",
        "width": 3072,
        "height": 2041
      },
      "title": "Community",
      "description": "Discover comfortable living at The Station Apartments, featuring modern exteriors and a welcoming community atmosphere.",
      "link": "",
      "alt_text": "Exterior of The Station Apartments building with a monument sign and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_39714e35-5fae-432e-9bf8-7cab6fdd048d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8071-0fd9-7791-abc2-0e4f8ce8e5ee.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with balconies and parking lot at The Station apartments in downtown Littleton, CO.",
        "public_id": "019f8071-0fd9-7791-abc2-0e4f8ce8e5ee",
        "storage_key": "property/6767906449166795/019f8071-0fd9-7791-abc2-0e4f8ce8e5ee.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "View of apartment building exteriors with balconies and a parking lot. Offers a glimpse of the community's architectural style and available parking.",
      "link": "",
      "alt_text": "Apartment building exterior with balconies and parking lot at The Station apartments in downtown Littleton, CO.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0788cd80-dbaa-4d80-9887-7f6a88518c2a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8071-100b-76b8-b314-c0ddfcfaff73.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment including tunnels and hoops at The Station apartments in downtown Littleton, CO.",
        "public_id": "019f8071-100b-76b8-b314-c0ddfcfaff73",
        "storage_key": "property/6767906449166795/019f8071-100b-76b8-b314-c0ddfcfaff73.webp",
        "width": 3072,
        "height": 2043
      },
      "title": "Community",
      "description": "Enjoy our spacious dog park, perfect for your furry friends to play and socialize.",
      "link": "",
      "alt_text": "Dog park with agility equipment including tunnels and hoops at The Station apartments in downtown Littleton, CO.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bbfb616c-7ef5-458e-b2ee-f62be93b25c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-e6a1-739f-b02f-3a94280a94b2.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings exterior with balconies and surrounding roads and trees  at The Station apartments in downtown Littleton, CO.",
        "public_id": "019f8070-e6a1-739f-b02f-3a94280a94b2",
        "storage_key": "property/6767906449166795/019f8070-e6a1-739f-b02f-3a94280a94b2.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Exterior view of modern apartment buildings with balconies, surrounded by trees and suburban landscape. Offers a glimpse of the community's architecture and setting.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings exterior with balconies and surrounding roads and trees  at The Station apartments in downtown Littleton, CO.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a35563c5-0232-4c36-80fc-8925b3b13910",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-e5cb-779b-beb8-1a5a9a79c0e2.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with covered parking and balconies  at The Station apartments in downtown Littleton, CO.",
        "public_id": "019f8070-e5cb-779b-beb8-1a5a9a79c0e2",
        "storage_key": "property/6767906449166795/019f8070-e5cb-779b-beb8-1a5a9a79c0e2.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Modern apartment buildings featuring covered parking, private balconies, and well-maintained exteriors.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with covered parking and balconies  at The Station apartments in downtown Littleton, CO.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7c0db371-f7ba-47e5-82d6-03544c9c54b5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-f278-74e2-b321-f99c010714ae.webp",
      "image_media": {
        "alt_text": "Apartment building with a fenced dog park in the foreground.",
        "public_id": "019f8070-f278-74e2-b321-f99c010714ae",
        "storage_key": "property/6767906449166795/019f8070-f278-74e2-b321-f99c010714ae.webp",
        "width": 3072,
        "height": 2045
      },
      "title": "Community",
      "description": "Enjoy our community amenities, including a dedicated dog park for your furry friends.",
      "link": "",
      "alt_text": "Apartment building with a fenced dog park in the foreground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e65a5a53-a4e5-4931-abeb-32b00852ad4a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-df35-767e-9744-bd2d078b6979.webp",
      "image_media": {
        "alt_text": "Exterior of a multifamily apartment building with multiple units and balconies at The Station apartments in downtown Littleton, CO.",
        "public_id": "019f8070-df35-767e-9744-bd2d078b6979",
        "storage_key": "property/6767906449166795/019f8070-df35-767e-9744-bd2d078b6979.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Modern multifamily apartment building exterior with multiple units and balconies, offering a comfortable living space.",
      "link": "",
      "alt_text": "Exterior of a multifamily apartment building with multiple units and balconies at The Station apartments in downtown Littleton, CO.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_76823493-eccb-4049-8b45-262194da87e6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-ca1a-7388-8f23-022562547b23.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and covered parking.",
        "public_id": "019f8070-ca1a-7388-8f23-022562547b23",
        "storage_key": "property/6767906449166795/019f8070-ca1a-7388-8f23-022562547b23.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming apartment building exterior featuring private balconies and convenient covered parking spaces.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and covered parking.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_007743f4-1348-4400-9d8c-369a6bb9c505",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-f947-73c7-bf4d-6e1a90be527e.webp",
      "image_media": {
        "alt_text": "Exterior of a multifamily property with balconies and a covered parking area at The Station apartments in downtown Littleton, CO.",
        "public_id": "019f8070-f947-73c7-bf4d-6e1a90be527e",
        "storage_key": "property/6767906449166795/019f8070-f947-73c7-bf4d-6e1a90be527e.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Community",
      "description": "The exterior of the multifamily property features private balconies and a covered parking area, providing convenience and aesthetic appeal.",
      "link": "",
      "alt_text": "Exterior of a multifamily property with balconies and a covered parking area at The Station apartments in downtown Littleton, CO.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9c26a789-fbd1-4487-9f69-a8a20625aca9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-ddb6-77f9-bdf8-3cfe57cb0fc8.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with parking and a dog park.",
        "public_id": "019f8070-ddb6-77f9-bdf8-3cfe57cb0fc8",
        "storage_key": "property/6767906449166795/019f8070-ddb6-77f9-bdf8-3cfe57cb0fc8.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Modern apartment buildings with covered parking and an adjacent dog park, showcasing community amenities.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with parking and a dog park.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4d6f6556-6854-4ae8-baa4-311398f546e8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-caf3-744c-a3e9-9f2a08b3b21c.webp",
      "image_media": {
        "alt_text": "Walkway between apartment buildings with trees and landscaping at The Station apartments in downtown Littleton, CO.",
        "public_id": "019f8070-caf3-744c-a3e9-9f2a08b3b21c",
        "storage_key": "property/6767906449166795/019f8070-caf3-744c-a3e9-9f2a08b3b21c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings showing walkways, balconies, and lush greenery, creating a pleasant community atmosphere.",
      "link": "",
      "alt_text": "Walkway between apartment buildings with trees and landscaping at The Station apartments in downtown Littleton, CO.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0551ad4a-3654-4cf0-b18c-82c4b7d8434c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-cc01-719b-82a1-c3e0e583ba75.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with balconies and a walkway.",
        "public_id": "019f8070-cc01-719b-82a1-c3e0e583ba75",
        "storage_key": "property/6767906449166795/019f8070-cc01-719b-82a1-c3e0e583ba75.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Modern apartment complex featuring charming architecture, private balconies, and lush green walkways for a comfortable living experience.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with balconies and a walkway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_11559b4a-51d9-4343-96a2-3a4e151c80b2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-a91c-76eb-aa04-0317c818a17f.webp",
      "image_media": {
        "alt_text": "Exterior of a modern apartment building with balconies and trees.",
        "public_id": "019f8070-a91c-76eb-aa04-0317c818a17f",
        "storage_key": "property/6767906449166795/019f8070-a91c-76eb-aa04-0317c818a17f.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "A view of the exterior of a modern apartment complex, showcasing its architecture, balconies, and surrounding greenery.",
      "link": "",
      "alt_text": "Exterior of a modern apartment building with balconies and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cf03f851-2ca3-411c-aaa0-5d851fc208cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-aac5-707a-a438-239c89749ea8.webp",
      "image_media": {
        "alt_text": "An aerial view of a fenced-in dog park with artificial turf and agility equipment at The Station apartments in downtown Littleton, CO.",
        "public_id": "019f8070-aac5-707a-a438-239c89749ea8",
        "storage_key": "property/6767906449166795/019f8070-aac5-707a-a438-239c89749ea8.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy our community dog park, featuring artificial turf, agility equipment, and ample space for your furry friends to play and socialize.",
      "link": "",
      "alt_text": "An aerial view of a fenced-in dog park with artificial turf and agility equipment at The Station apartments in downtown Littleton, CO.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_210e779d-1cb0-49a9-8544-4661e6672b39",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-a951-74fe-a1ed-7bc53833b447.webp",
      "image_media": {
        "alt_text": "Apartment building exterior at dusk with illuminated windows and balconies at The Station apartments in downtown Littleton, CO.",
        "public_id": "019f8070-a951-74fe-a1ed-7bc53833b447",
        "storage_key": "property/6767906449166795/019f8070-a951-74fe-a1ed-7bc53833b447.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "View of the apartment building exterior during a beautiful sunset, showcasing illuminated windows and balconies, with parking available.",
      "link": "",
      "alt_text": "Apartment building exterior at dusk with illuminated windows and balconies at The Station apartments in downtown Littleton, CO.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_83457af3-ea96-48eb-b1ab-22e8f3586e34",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-a91b-73d9-976e-1d938c93c1c1.webp",
      "image_media": {
        "alt_text": "Dog park with green turf, agility equipment, and seating areas adjacent to parking lot and apartment buildings.",
        "public_id": "019f8070-a91b-73d9-976e-1d938c93c1c1",
        "storage_key": "property/6767906449166795/019f8070-a91b-73d9-976e-1d938c93c1c1.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy our spacious dog park, perfect for your furry friends to play and socialize. Features include agility equipment and comfortable seating for owners.",
      "link": "",
      "alt_text": "Dog park with green turf, agility equipment, and seating areas adjacent to parking lot and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ea07c41f-e65c-4a97-b3a4-2ea8699f7673",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8071-2d79-7378-abbe-9840f894153c.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with shelves and hanging rods at The Station apartments in downtown Littleton, CO.",
        "public_id": "019f8071-2d79-7378-abbe-9840f894153c",
        "storage_key": "property/6767906449166795/019f8071-2d79-7378-abbe-9840f894153c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with carpeted floor and built-in shelving and hanging rods, ready for your wardrobe.",
      "link": "",
      "alt_text": "Empty walk-in closet with shelves and hanging rods at The Station apartments in downtown Littleton, CO.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cca7677e-3e4b-4e56-b8bc-174845f0fdc7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8071-2a0f-7336-86f2-822566d52eb6.webp",
      "image_media": {
        "alt_text": "Empty apartment bedroom with beige walls, carpet, and a window with blinds.",
        "public_id": "019f8071-2a0f-7336-86f2-822566d52eb6",
        "storage_key": "property/6767906449166795/019f8071-2a0f-7336-86f2-822566d52eb6.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "A view of an empty bedroom with neutral-toned walls and carpeting. The room features a window with blinds, allowing natural light to enter.",
      "link": "",
      "alt_text": "Empty apartment bedroom with beige walls, carpet, and a window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f5be979e-5744-441b-9e6a-fc546ce745a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8071-246c-7645-9299-dc0f61c2f488.webp",
      "image_media": {
        "alt_text": "Bathroom with a white tub, toilet, and vanity with a white countertop and sink at The Station apartments in downtown Littleton, CO.",
        "public_id": "019f8071-246c-7645-9299-dc0f61c2f488",
        "storage_key": "property/6767906449166795/019f8071-246c-7645-9299-dc0f61c2f488.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a white bathtub, toilet, and a vanity with a white countertop and sink. The space is well-lit with vanity lighting above a large mirror.",
      "link": "",
      "alt_text": "Bathroom with a white tub, toilet, and vanity with a white countertop and sink at The Station apartments in downtown Littleton, CO.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_af625cbd-9152-4ed5-ba48-bc6fb3a2181b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8071-1916-7327-805b-cd86bfa94ed1.webp",
      "image_media": {
        "alt_text": "Kitchenette with stainless steel appliances and in-unit stacked washer and dryer at The Station apartments in downtown Littleton, CO.",
        "public_id": "019f8071-1916-7327-805b-cd86bfa94ed1",
        "storage_key": "property/6767906449166795/019f8071-1916-7327-805b-cd86bfa94ed1.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Cozy kitchenette featuring stainless steel appliances and a convenient in-unit stacked washer and dryer for all your laundry needs.",
      "link": "",
      "alt_text": "Kitchenette with stainless steel appliances and in-unit stacked washer and dryer at The Station apartments in downtown Littleton, CO.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_53505aa5-9be3-4f0e-851b-f9fd5c6d026b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8071-18a2-7568-9c25-621876ee7a9d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and white countertops.",
        "public_id": "019f8071-18a2-7568-9c25-621876ee7a9d",
        "storage_key": "property/6767906449166795/019f8071-18a2-7568-9c25-621876ee7a9d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this stylish kitchen featuring stainless steel appliances, ample counter space, and sleek cabinetry.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and white countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5503a329-a6c3-4409-8b76-c39ea9162d17",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8071-0fb4-7340-be3a-3c35bb294add.webp",
      "image_media": {
        "alt_text": "Spacious living room with modern kitchen and sliding glass door at The Station apartments in downtown Littleton, CO.",
        "public_id": "019f8071-0fb4-7340-be3a-3c35bb294add",
        "storage_key": "property/6767906449166795/019f8071-0fb4-7340-be3a-3c35bb294add.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Enjoy this bright and airy living space with a contemporary kitchen, perfect for entertaining or relaxing. Features a sliding glass door for easy outdoor access.",
      "link": "",
      "alt_text": "Spacious living room with modern kitchen and sliding glass door at The Station apartments in downtown Littleton, CO.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ba306fd4-b9e6-461d-8e6c-bf948eae82c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8071-0f51-7778-9a7a-710f5eebd3fa.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white countertops, and a subway tile backsplash at The Station apartments in downtown Littleton, CO.",
        "public_id": "019f8071-0f51-7778-9a7a-710f5eebd3fa",
        "storage_key": "property/6767906449166795/019f8071-0f51-7778-9a7a-710f5eebd3fa.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Updated kitchen featuring sleek cabinetry, a stainless steel refrigerator, microwave, and range, complemented by a stylish mosaic tile backsplash and ample counter space.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white countertops, and a subway tile backsplash at The Station apartments in downtown Littleton, CO.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_75f025c9-6112-4ccf-aebe-a346ceb524eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8071-1707-75ba-8344-97bbe0a13e73.webp",
      "image_media": {
        "alt_text": "Modern kitchen with gray cabinets and white countertops featuring a large sink and faucet.",
        "public_id": "019f8071-1707-75ba-8344-97bbe0a13e73",
        "storage_key": "property/6767906449166795/019f8071-1707-75ba-8344-97bbe0a13e73.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Step into this beautifully designed kitchen, complete with sleek gray cabinetry and expansive white countertops. Perfect for preparing meals or entertaining guests.",
      "link": "",
      "alt_text": "Modern kitchen with gray cabinets and white countertops featuring a large sink and faucet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3799de94-7466-4956-b8c9-c908a484d4f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8071-10ce-708e-b383-e9cca1916642.webp",
      "image_media": {
        "alt_text": "Living room with wood floors and a sliding glass door to a balcony at The Station apartments in downtown Littleton, CO.",
        "public_id": "019f8071-10ce-708e-b383-e9cca1916642",
        "storage_key": "property/6767906449166795/019f8071-10ce-708e-b383-e9cca1916642.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Spacious living room featuring elegant wood-style flooring and a private balcony accessible through a sliding glass door, perfect for enjoying the outdoors.",
      "link": "",
      "alt_text": "Living room with wood floors and a sliding glass door to a balcony at The Station apartments in downtown Littleton, CO.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1baae0fc-2427-410f-9e00-496a756772df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-dd27-747c-87b5-c0ef4701bd7b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and black hexagon tile backsplash at The Station apartments in downtown Littleton, CO.",
        "public_id": "019f8070-dd27-747c-87b5-c0ef4701bd7b",
        "storage_key": "property/6767906449166795/019f8070-dd27-747c-87b5-c0ef4701bd7b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "A bright and updated kitchen featuring stainless steel appliances, a microwave, range, refrigerator, and a stylish black hexagon tile backsplash.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and black hexagon tile backsplash at The Station apartments in downtown Littleton, CO.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bef2517d-6a7c-4e7e-8eb6-9c9783b388a4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-f2e5-74dd-82d3-e6350119e560.webp",
      "image_media": {
        "alt_text": "Spacious living area with wood-look flooring, sliding glass doors to a balcony, and a closet at The Station apartments in downtown Littleton, CO.",
        "public_id": "019f8070-f2e5-74dd-82d3-e6350119e560",
        "storage_key": "property/6767906449166795/019f8070-f2e5-74dd-82d3-e6350119e560.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Bright and airy living space featuring modern wood-look flooring and ample natural light from the balcony doors and windows. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Spacious living area with wood-look flooring, sliding glass doors to a balcony, and a closet at The Station apartments in downtown Littleton, CO.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9f542a7d-44fb-4419-92fe-9fd4aec03c74",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-ced8-7028-a367-4c764f7831a4.webp",
      "image_media": {
        "alt_text": "Empty living room with a balcony and AC unit at The Station apartments in downtown Littleton, CO.",
        "public_id": "019f8070-ced8-7028-a367-4c764f7831a4",
        "storage_key": "property/6767906449166795/019f8070-ced8-7028-a367-4c764f7831a4.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious living room featuring hardwood floors, a sliding glass door leading to a balcony, and an air conditioning unit.",
      "link": "",
      "alt_text": "Empty living room with a balcony and AC unit at The Station apartments in downtown Littleton, CO.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_29eaeff8-67a7-4174-a29b-0d30098d647b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-ccd0-74bf-8f3c-d3636b4582bf.webp",
      "image_media": {
        "alt_text": "On-site laundry facility with multiple washers and dryers at The Station apartments in downtown Littleton, CO.",
        "public_id": "019f8070-ccd0-74bf-8f3c-d3636b4582bf",
        "storage_key": "property/6767906449166795/019f8070-ccd0-74bf-8f3c-d3636b4582bf.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities equipped with multiple washers and dryers for residents.",
      "link": "",
      "alt_text": "On-site laundry facility with multiple washers and dryers at The Station apartments in downtown Littleton, CO.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5da2faae-9d56-408d-9dc5-b65bda942734",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-c8d7-702d-868b-cd2ef6811122.webp",
      "image_media": {
        "alt_text": "Community laundry room with washers, dryers, seating, and a folding table.",
        "public_id": "019f8070-c8d7-702d-868b-cd2ef6811122",
        "storage_key": "property/6767906449166795/019f8070-c8d7-702d-868b-cd2ef6811122.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities make chores a breeze, featuring multiple washers, dryers, comfortable seating, and ample folding space.",
      "link": "",
      "alt_text": "Community laundry room with washers, dryers, seating, and a folding table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fb2a1824-ed63-4345-96a5-062a9a2aaf75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-e0d4-742e-8dfb-b03ac46fba78.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and bathtub with shower at The Station apartments in downtown Littleton, CO.",
        "public_id": "019f8070-e0d4-742e-8dfb-b03ac46fba78",
        "storage_key": "property/6767906449166795/019f8070-e0d4-742e-8dfb-b03ac46fba78.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a spacious vanity with a white countertop, a sleek sink, and a large mirror. It also includes a toilet and a bathtub with a tiled shower surround.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and bathtub with shower at The Station apartments in downtown Littleton, CO.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d0183d22-0b9d-4895-8889-2567b45fd90e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-c9bb-775a-89ce-32e041088ee2.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and white countertops at The Station apartments in downtown Littleton, CO.",
        "public_id": "019f8070-c9bb-775a-89ce-32e041088ee2",
        "storage_key": "property/6767906449166795/019f8070-c9bb-775a-89ce-32e041088ee2.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring stainless steel appliances, ample counter space, and modern cabinetry.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and white countertops at The Station apartments in downtown Littleton, CO.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_106a5140-4817-42d2-ba66-49546bdcd3c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-c7db-70fa-817a-a5f584e27e1f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinets at The Station apartments in downtown Littleton, CO.",
        "public_id": "019f8070-c7db-70fa-817a-a5f584e27e1f",
        "storage_key": "property/6767906449166795/019f8070-c7db-70fa-817a-a5f584e27e1f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this beautifully updated kitchen, featuring stainless steel appliances, ample cabinet space, and sleek countertops. Perfect for preparing meals and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and white cabinets at The Station apartments in downtown Littleton, CO.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3d56ff79-e4c7-42dd-916f-d4a07447667a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-c8a7-75cd-ba40-849ea51aa493.webp",
      "image_media": {
        "alt_text": "Empty apartment living area with kitchen and closet at The Station apartments in downtown Littleton, CO.",
        "public_id": "019f8070-c8a7-75cd-ba40-849ea51aa493",
        "storage_key": "property/6767906449166795/019f8070-c8a7-75cd-ba40-849ea51aa493.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious living area and kitchen in a modern apartment, perfect for comfortable living.",
      "link": "",
      "alt_text": "Empty apartment living area with kitchen and closet at The Station apartments in downtown Littleton, CO.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ec42de81-9899-435a-87ab-b4fbbda722eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019f8070-c9ba-74f2-bd97-069b65e9fe8c.webp",
      "image_media": {
        "alt_text": "Interior hallway with a closet at The Station apartments in downtown Littleton, CO.",
        "public_id": "019f8070-c9ba-74f2-bd97-069b65e9fe8c",
        "storage_key": "property/6767906449166795/019f8070-c9ba-74f2-bd97-069b65e9fe8c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Hallway with closet space and wood-look flooring.",
      "link": "",
      "alt_text": "Interior hallway with a closet at The Station apartments in downtown Littleton, CO.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_fb1adb24-46dd-44dc-8d85-640556e6434b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "Sushi Den",
      "poi_type": "Restaurants",
      "poi_address": "1487 S Pearl St, Denver, CO 80210, USA",
      "poi_short_description": "Fish is flown in daily from Tokyo at this hopping Japanese venue with takeout options.",
      "poi_long_description": "People say this sushi restaurant serves fresh, delicious sushi flown in daily from Japan, including toro, hamachi, and miso black cod. They highlight the amazing experience, the attentive and knowledgeable staff, and the unique chef's table. They also like the beautiful presentation and the lively, cozy atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02cf-fbfb-7368-ae9f-0b0bf2fa4f9a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-fbfb-7368-ae9f-0b0bf2fa4f9a",
        "storage_key": "property/6767906449166795/019d02cf-fbfb-7368-ae9f-0b0bf2fa4f9a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.sushiden.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12975132885708167184&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sushi-den",
      "poi_latitude": "39.689578",
      "poi_longitude": "-104.9808419",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 303-777-0826",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-4afd-767b-994e-dfdda2bf81ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-4afd-767b-994e-dfdda2bf81ba",
        "storage_key": "property/6767906449166795/019d02d0-4afd-767b-994e-dfdda2bf81ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL2TJFlJ-bIcRENgfRp3uELQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_f6d6203f-d115-4fe2-8f48-359085a04960",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "Dave & Buster's Denver",
      "poi_type": "Restaurants",
      "poi_address": "2000 S Colorado Blvd, Denver, CO 80222, USA",
      "poi_short_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_long_description": "People say this restaurant offers a wide variety of games and delicious food, including wings, fries, and burgers. They also highlight the fun atmosphere, friendly and helpful staff, and the great time they have with family and friends.\n\nSome reviews mention the games can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02cf-fc85-7364-8092-092305bebf10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-fc85-7364-8092-092305bebf10",
        "storage_key": "property/6767906449166795/019d02cf-fc85-7364-8092-092305bebf10.webp",
        "width": 1280,
        "height": 864
      },
      "poi_business_url": "https://www.daveandbusters.com/us/en/about/locations/denver",
      "poi_directions_map_url": "https://maps.google.com/?cid=16160522503424918720&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dave--busters-denver",
      "poi_latitude": "39.680988",
      "poi_longitude": "-104.939385",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 303-759-1515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-4afd-767b-994e-dfdda2bf81ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-4afd-767b-994e-dfdda2bf81ba",
        "storage_key": "property/6767906449166795/019d02d0-4afd-767b-994e-dfdda2bf81ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsy3kluF9bIcRwERZQZi1ReA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_b82d2261-f305-4bc7-b24f-b9185aa703fe",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "Angelo's Taverna - Littleton",
      "poi_type": "Restaurants",
      "poi_address": "6885 S Santa Fe Dr a, Littleton, CO 80120, USA",
      "poi_short_description": "Casual Italian plates, plus oysters & a full bar, featured in homey surroundings.",
      "poi_long_description": "Diners say this eclectic Italian restaurant serves up delicious oysters, lobster gnocchi, and chicken parmesan. They also highlight the friendly and attentive staff, and the lively atmosphere with a great patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-84ab-7697-88b4-e0bc85675777.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-84ab-7697-88b4-e0bc85675777",
        "storage_key": "property/6767906449166795/019d02d0-84ab-7697-88b4-e0bc85675777.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://angeloslittleton.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15219784845904966960&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "angelos-taverna---littleton",
      "poi_latitude": "39.5921999",
      "poi_longitude": "-105.0228161",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 720-532-1389",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-4afd-767b-994e-dfdda2bf81ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-4afd-767b-994e-dfdda2bf81ba",
        "storage_key": "property/6767906449166795/019d02d0-4afd-767b-994e-dfdda2bf81ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLVTlgOeBbIcRMPUJ8q2JN9M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_41d7bd7b-1222-4414-92e2-b61acde747cf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "Lazy Dog Restaurant & Bar",
      "poi_type": "Restaurants",
      "poi_address": "43 Centennial Blvd, Highlands Ranch, CO 80129, USA",
      "poi_short_description": "Relaxed, lodge-chic chain serving global comfort fare, including stir-fries, pot roast & pastas.",
      "poi_long_description": "People say this restaurant offers a varied and interesting menu with dishes like chicken pot pie, bison burger, and umami fries. They highlight the lively atmosphere, reasonable prices, and dog-friendly patio. They also like the attentive and professional service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-85b4-71bf-991f-4e3f91a4d6d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-85b4-71bf-991f-4e3f91a4d6d6",
        "storage_key": "property/6767906449166795/019d02d0-85b4-71bf-991f-4e3f91a4d6d6.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://lazydogrestaurants.com/locations/highlands-ranch-co",
      "poi_directions_map_url": "https://maps.google.com/?cid=2390830412732983173&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lazy-dog-restaurant--bar",
      "poi_latitude": "39.5626642",
      "poi_longitude": "-104.988466",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 720-741-2942",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-4afd-767b-994e-dfdda2bf81ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-4afd-767b-994e-dfdda2bf81ba",
        "storage_key": "property/6767906449166795/019d02d0-4afd-767b-994e-dfdda2bf81ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgYGui6eDbIcRhWcm3ZfvLSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_1176cc30-095f-4edf-8df3-d8d8fc236016",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "Main Event Highlands Ranch",
      "poi_type": "Restaurants",
      "poi_address": "64 Centennial Blvd, Highlands Ranch, CO 80129, USA",
      "poi_short_description": "Playful entertainment center featuring an arcade and bowling lanes as well as laser tag.",
      "poi_long_description": "Visitors say this entertainment center offers a wide variety of activities, including bowling, laser tag, a gravity ropes course, an arcade, and billiards, with a full bar and food service. They like the friendly staff, clean environment, and fun atmosphere for families and groups.\n\nSome reviews mention the wait times for activities can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-0299-762e-b922-f938614fac8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-0299-762e-b922-f938614fac8a",
        "storage_key": "property/6767906449166795/019d02d0-0299-762e-b922-f938614fac8a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mainevent.com/locations/colorado/highlands-ranch",
      "poi_directions_map_url": "https://maps.google.com/?cid=9630259167408020236&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "main-event-highlands-ranch",
      "poi_latitude": "39.5611391",
      "poi_longitude": "-104.9889766",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 303-209-3877",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-4afd-767b-994e-dfdda2bf81ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-4afd-767b-994e-dfdda2bf81ba",
        "storage_key": "property/6767906449166795/019d02d0-4afd-767b-994e-dfdda2bf81ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvUYpfOCDbIcRDNtNgLCNpYU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_12dad767-2a3c-4daa-b20c-9c262ac3ba89",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "5910 S University Blvd E1, Greenwood Village, CO 80121, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, fruits, meats, and unique, affordable, private-label items, like specialty snacks, coffee, and frozen meals. They highlight the good deals, low prices, and the fun, small-town grocery store feel. They also like the friendly, helpful, and welcoming staff.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://locations.traderjoes.com/co/greenwood-village/303/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=1453411962580863733&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "39.6091348",
      "poi_longitude": "-104.9573858",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 303-730-3848",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-4afe-739b-817a-efc86b18d05f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-4afe-739b-817a-efc86b18d05f",
        "storage_key": "property/6767906449166795/019d02d0-4afe-739b-817a-efc86b18d05f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuZfejDyBbIcR9YrvvXqOKxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b637cc14-76a5-493e-92c7-94ca5bd4ddc1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1111 S Washington St, Denver, CO 80210, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/washingtonpark?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=5738862899392445203&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "39.6960415",
      "poi_longitude": "-104.9798725",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 303-733-6201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-4afe-739b-817a-efc86b18d05f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-4afe-739b-817a-efc86b18d05f",
        "storage_key": "property/6767906449166795/019d02d0-4afe-739b-817a-efc86b18d05f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8xhNJlR-bIcRE3v0tGaJpE8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_eb29e34c-4d93-4535-9b1c-99fbaac9dd6d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "Southwest Plaza",
      "poi_type": "Shopping & Retail",
      "poi_address": "8501 W Bowles Ave, Littleton, CO 80123, USA",
      "poi_short_description": "Bustling mall with over 150 specialty retailers anchored by Macy's & Dillard's, plus a food court.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores and restaurants, and is clean and spacious. They also highlight the relaxed atmosphere, family-friendly activities, and comfortable seating.\n\nOther reviews mention some stores can be closed.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.southwestplaza.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=3138709075714181309&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southwest-plaza",
      "poi_latitude": "39.612175",
      "poi_longitude": "-105.095685",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 303-973-7062",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-4b10-753c-9d96-b3cd5ba13e22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-4b10-753c-9d96-b3cd5ba13e22",
        "storage_key": "property/6767906449166795/019d02d0-4b10-753c-9d96-b3cd5ba13e22.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJMZtL9Bp_a4cRvQg9V0bvjis",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_1c331cf8-f38c-4e27-9cec-bc810d26cefb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "1200 Mayberry Dr, Highlands Ranch, CO 80129, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers helpful staff who go above and beyond to assist customers with their DIY projects, and they appreciate the friendly and fast service. They also highlight the knowledgeable staff who can help find the right materials and tools.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.homedepot.com/l/Highlands-Ranch/CO/Highlands-Ranch/80129/1540?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=9187955057105761828&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "39.5453119",
      "poi_longitude": "-105.0009513",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 720-344-7645",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-4b10-753c-9d96-b3cd5ba13e22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-4b10-753c-9d96-b3cd5ba13e22",
        "storage_key": "property/6767906449166795/019d02d0-4b10-753c-9d96-b3cd5ba13e22.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhSgxxUSCbIcRJPYKz3Esgn8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_85792fea-8d28-45e1-89c8-33fe1338f33a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "University of Denver",
      "poi_type": "Education",
      "poi_address": "Denver, CO 80210, USA",
      "poi_short_description": "Circa-1864 private university with a tree-lined campus located just outside Downtown Denver.",
      "poi_long_description": "Circa-1864 private university with a tree-lined campus located just outside Downtown Denver.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-0ae7-7151-9c06-3f7bbf12bc71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-0ae7-7151-9c06-3f7bbf12bc71",
        "storage_key": "property/6767906449166795/019d02d0-0ae7-7151-9c06-3f7bbf12bc71.webp",
        "width": 1280,
        "height": 508
      },
      "poi_business_url": "https://www.du.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8185476086261295065&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-denver",
      "poi_latitude": "39.6766174",
      "poi_longitude": "-104.9618965",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 303-871-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-4b06-707c-b934-1f64b62b07b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-4b06-707c-b934-1f64b62b07b2",
        "storage_key": "property/6767906449166795/019d02d0-4b06-707c-b934-1f64b62b07b2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYafenBV-bIcR2ScPxyGnmHE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_78d90a9e-242b-4fb5-85e8-6826356c81eb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "Arapahoe Community College",
      "poi_type": "Education",
      "poi_address": "5900 S Santa Fe Dr, Littleton, CO 80120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-0bd8-77a4-aefd-1114b80d5d68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-0bd8-77a4-aefd-1114b80d5d68",
        "storage_key": "property/6767906449166795/019d02d0-0bd8-77a4-aefd-1114b80d5d68.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.arapahoe.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6167192513140241113&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "arapahoe-community-college",
      "poi_latitude": "39.6080683",
      "poi_longitude": "-105.0188452",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 303-797-4222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-4b06-707c-b934-1f64b62b07b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-4b06-707c-b934-1f64b62b07b2",
        "storage_key": "property/6767906449166795/019d02d0-4b06-707c-b934-1f64b62b07b2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ58mDb86BbIcR2TIsX-pEllU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_451fe032-4bd1-447e-b313-f7f351365d0f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "Pirates Cove Water Park",
      "poi_type": "Entertainment",
      "poi_address": "1225 W Belleview Ave, Littleton, CO 80120, USA",
      "poi_short_description": "Seasonal outdoor park with leisure & lap pools, 35-ft. slide, tubing river & concession stand.",
      "poi_long_description": "Visitors say this water park offers a lazy river, slides, a kiddie area, and a large pool, and they appreciate that it's clean, fun, and affordable. They also highlight the attentive lifeguards and the family-friendly atmosphere.\n\nSome reviews mention the water park can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-88e9-716b-b771-686a3962c638.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-88e9-716b-b771-686a3962c638",
        "storage_key": "property/6767906449166795/019d02d0-88e9-716b-b771-686a3962c638.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.piratescovecolorado.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6511626523483944042&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pirates-cove-water-park",
      "poi_latitude": "39.6247196",
      "poi_longitude": "-105.0027914",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 303-762-2683",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-4ffa-7341-a65c-c8872a04171b",
        "storage_key": "property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1TaeWk-AbIcRarRFstLxXVo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_1b398759-19aa-4b81-8ecb-c7f0fb561641",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "Magness Arena",
      "poi_type": "Entertainment",
      "poi_address": "2250 E Jewell Ave, Denver, CO 80208, USA",
      "poi_short_description": "Home arena of the University of Denver's men's ice hockey and women's gymnastics teams.",
      "poi_long_description": "People say this arena offers a great experience for watching hockey games, with comfortable seats, cup holders, and a large selection of food and drinks. They highlight the easy access, convenient parking, and clean facilities. They also like the family-friendly vibe and excellent sight lines.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-8a51-719a-b5d8-03ea4ba91720.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-8a51-719a-b5d8-03ea4ba91720",
        "storage_key": "property/6767906449166795/019d02d0-8a51-719a-b5d8-03ea4ba91720.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://denverpioneers.com/index.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=9733327968231369636&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "magness-arena",
      "poi_latitude": "39.68212219999999",
      "poi_longitude": "-104.9616342",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 303-871-4625",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-4ffa-7341-a65c-c8872a04171b",
        "storage_key": "property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYafenBV-bIcRpCvOvDe6E4c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_c3ccf285-aeba-4174-9d20-0b55146093e7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "Littleton Museum",
      "poi_type": "Entertainment",
      "poi_address": "6028 S Gallup St, Littleton, CO 80120, USA",
      "poi_short_description": "Living-history farms representing the 1860s & 1890s, plus a museum showcasing local artifacts.",
      "poi_long_description": "People say this museum offers interactive exhibits, historic farms, and a glimpse into 19th-century life with reenactors and heritage farm animals. They highlight the educational and engaging experience, suitable for both children and adults, and the well-maintained grounds. They also like the friendly and knowledgeable staff and volunteers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-126d-71fe-8c8d-ef98cf1fc6b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-126d-71fe-8c8d-ef98cf1fc6b7",
        "storage_key": "property/6767906449166795/019d02d0-126d-71fe-8c8d-ef98cf1fc6b7.webp",
        "width": 600,
        "height": 331
      },
      "poi_business_url": "https://www.museum.littletonco.gov/Home",
      "poi_directions_map_url": "https://maps.google.com/?cid=2271002714073128988&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "littleton-museum",
      "poi_latitude": "39.60671380000001",
      "poi_longitude": "-105.0017159",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 303-795-3950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-501d-7109-b118-464d34ddd2b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-501d-7109-b118-464d34ddd2b5",
        "storage_key": "property/6767906449166795/019d02d0-501d-7109-b118-464d34ddd2b5.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJj1iV6bCBbIcRHOBGqO84hB8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_07eb5ee2-1d76-4087-ad4f-2f2ecdd3016b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "Highlands Ranch Mansion",
      "poi_type": "Entertainment",
      "poi_address": "9950 E Gateway Dr, Highlands Ranch, CO 80126, USA",
      "poi_short_description": "Elegant venue offering tours of its historic house, gardens and events space.",
      "poi_long_description": "People say this museum offers a beautiful historical mansion with informative exhibits in each room, and lovely rooms and views. They highlight the easy accessibility for wheelchairs, the interesting history, and the well-maintained grounds. They also like the knowledgeable docents and the smooth event planning process.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-8bf1-762c-b718-cb27432ec399.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-8bf1-762c-b718-cb27432ec399",
        "storage_key": "property/6767906449166795/019d02d0-8bf1-762c-b718-cb27432ec399.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "https://highlandsranchmansion.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8393423835962820058&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "highlands-ranch-mansion",
      "poi_latitude": "39.5360422",
      "poi_longitude": "-104.9712652",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 303-791-0177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-501d-7109-b118-464d34ddd2b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-501d-7109-b118-464d34ddd2b5",
        "storage_key": "property/6767906449166795/019d02d0-501d-7109-b118-464d34ddd2b5.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJx2ZoVAiDbIcR2kXcL4Jue3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_f5cfcf18-f09d-45ac-b812-325337b8140d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "8196 W Bowles Ave, Columbine Valley, CO 80123, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "Visitors say this amusement park is a great place to throw birthday parties, with fun attractions like laser tag, bumper cars, and a climbing area. They also highlight the friendly and helpful staff, and the surprisingly good pizza and snacks.\n\nSome reviews mention the equipment can be out of service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-16d6-75bd-8438-10b6a30676bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-16d6-75bd-8438-10b6a30676bf",
        "storage_key": "property/6767906449166795/019d02d0-16d6-75bd-8438-10b6a30676bf.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.urbanair.com/colorado-littleton/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=2066539728783733930&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "39.6080153",
      "poi_longitude": "-105.0904217",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 720-900-2833",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-4ffa-7341-a65c-c8872a04171b",
        "storage_key": "property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjcu1j2h_a4cRqvRiMO_SrRw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_b801fadd-5250-4959-a036-de6a6d33d20e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "5000 E Dry Creek Rd, Centennial, CO 80122, USA",
      "poi_short_description": "Fitness center with a pool, a cafe, tennis courts, hot tubs, and a climbing wall.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, amenities, and activities, including a pool, pickleball courts, and massage chairs, and has a friendly community.\n\nOther reviews mention the equipment can be poorly maintained and the facilities can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-17bf-74fe-b08f-1755c7b440c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-17bf-74fe-b08f-1755c7b440c1",
        "storage_key": "property/6767906449166795/019d02d0-17bf-74fe-b08f-1755c7b440c1.webp",
        "width": 1088,
        "height": 1088
      },
      "poi_business_url": "https://www.lifetime.life/locations/co/centennial.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=9918587989340997961&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "39.5776708",
      "poi_longitude": "-104.9287006",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 720-489-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-4ffa-7341-a65c-c8872a04171b",
        "storage_key": "property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD7tI2AOEbIcRSUkgsjnnpYk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6bc23e75-b03b-4b3f-a543-fc10d09a7e3d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "Club Greenwood",
      "poi_type": "Health and Wellness",
      "poi_address": "5801 S Quebec St, Greenwood Village, CO 80111, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this fitness center offers a wide variety of fitness classes, a large weight room, and multiple pools. They also highlight the clean facilities, spacious locker rooms with amenities like a sauna and steam room, and the kind and welcoming staff.\n\nOther reviews mention the cancellation policy can be frustrating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-8f34-750f-9b33-9a3a99e814b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-8f34-750f-9b33-9a3a99e814b0",
        "storage_key": "property/6767906449166795/019d02d0-8f34-750f-9b33-9a3a99e814b0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://clubgreenwood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7160767558804374953&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "club-greenwood",
      "poi_latitude": "39.610557",
      "poi_longitude": "-104.9056307",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 303-770-2582",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-4ffa-7341-a65c-c8872a04171b",
        "storage_key": "property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGcQRlu2GbIcRqQWtxScoYGM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_d9ef450e-aa82-41c2-9e8b-5816f290a869",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "Chuze Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "200 W Belleview Ave, Englewood, CO 80110, USA",
      "poi_short_description": "Friendly, clean fitness center, also offering free weights, an indoor pool, saunas and more.",
      "poi_long_description": "Gym goers say this fitness center offers a wide variety of amenities, including a sauna, hot tub, hydro massage chairs, and a pool, and they appreciate the friendly and helpful staff. They also highlight the great value for the price, with many mentioning the extensive selection of equipment and group classes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-1a55-7658-8a5e-e51899d23f6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-1a55-7658-8a5e-e51899d23f6b",
        "storage_key": "property/6767906449166795/019d02d0-1a55-7658-8a5e-e51899d23f6b.webp",
        "width": 890,
        "height": 501
      },
      "poi_business_url": "https://chuzefitness.com/gym-locations/co/englewood/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13674413025060354440&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chuze-fitness",
      "poi_latitude": "39.6225242",
      "poi_longitude": "-104.9908447",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 720-210-9990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-4ffa-7341-a65c-c8872a04171b",
        "storage_key": "property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3T6D3_yBbIcRiHmyNjJGxb0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_88d4a223-d95a-42e2-babb-6f590851c389",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "VASA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8055 W Bowles Ave STE 1300, Littleton, CO 80123, USA",
      "poi_short_description": "Open-layout athletic club with an indoor pool and basketball courts, as well as a cinema area.",
      "poi_long_description": "People say this gym has a great selection of equipment, a clean facility, and friendly staff. They also highlight the affordable prices, the variety of classes, and the relaxing amenities like the sauna and steam room.\n\nSome reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-1f2a-731d-9ae4-2b11ba559bfb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-1f2a-731d-9ae4-2b11ba559bfb",
        "storage_key": "property/6767906449166795/019d02d0-1f2a-731d-9ae4-2b11ba559bfb.webp",
        "width": 1280,
        "height": 870
      },
      "poi_business_url": "https://vasafitness.com/locations/co/littleton/?utm_medium=organic&utm_source=GMBlisting&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=10129490966511973896&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vasa-fitness",
      "poi_latitude": "39.611724",
      "poi_longitude": "-105.0888051",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 720-981-8272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-4ffa-7341-a65c-c8872a04171b",
        "storage_key": "property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeUaRAwV_a4cRCHZ5nl0uk4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e28b5a48-bedc-4dbe-946d-e599810e8069",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "Traverse Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2449 S Broadway, Denver, CO 80210, USA",
      "poi_short_description": "Coached group classes (HIIT, strength, altitude-training, and mixed), plus a cold tub and a sauna.",
      "poi_long_description": "People say this fitness center offers a variety of workouts, including HIIT classes, weightlifting, and treadmill options, as well as open gym time. They highlight the high energy, inspiring environment, and the supportive community with social events and interest groups. They also like the amenities, such as a sauna, cold plunges, coworking space, and recovery equipment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-1fde-740e-8e3d-9b4c69e3dae4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-1fde-740e-8e3d-9b4c69e3dae4",
        "storage_key": "property/6767906449166795/019d02d0-1fde-740e-8e3d-9b4c69e3dae4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.traversefitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=43645833569465205&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "traverse-fitness",
      "poi_latitude": "39.67208979999999",
      "poi_longitude": "-104.9879662",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 303-733-0303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-4ffa-7341-a65c-c8872a04171b",
        "storage_key": "property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI72UbHB_bIcRdXPVhacPmwA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_3fe7e2a0-43e0-4f77-81ab-3b325811e434",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "University Hills - Schlessman YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "3901 E Yale Ave, Denver, CO 80210, USA",
      "poi_short_description": "Membership gym and rec center offering exercise classes, swimming and basketball for adults and children.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-2665-77c8-9260-e8f25278bc23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-2665-77c8-9260-e8f25278bc23",
        "storage_key": "property/6767906449166795/019d02d0-2665-77c8-9260-e8f25278bc23.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://denverymca.org/locations/university-hills-schlessman-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=3917970440262964707&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-hills---schlessman-ymca",
      "poi_latitude": "39.667728",
      "poi_longitude": "-104.9416496",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 720-524-2755",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-4ffa-7341-a65c-c8872a04171b",
        "storage_key": "property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG7tpKwF-bIcR49VabFttXzY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_be1ebe08-4db8-49f0-8c45-47b27e4af61c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1865 W Mississippi Ave, Denver, CO 80223, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this fitness center offers a wide variety of new equipment, including plate-loaded machines, and amenities like massage chairs, tanning booths, and red light therapy chambers. They also highlight the clean facilities, well-maintained equipment, and friendly, helpful staff.\n\nSome reviews mention the gym can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-94ec-7172-830f-92655d72614b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-94ec-7172-830f-92655d72614b",
        "storage_key": "property/6767906449166795/019d02d0-94ec-7172-830f-92655d72614b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/?utm_medium=yext&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=17788296102758851457&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "39.6970633",
      "poi_longitude": "-105.0103369",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 720-543-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-4ffa-7341-a65c-c8872a04171b",
        "storage_key": "property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5-M0HH9_bIcRgSNoHA-53PY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_0ae18212-b00f-41bb-bdd7-6fd4e58fa4a9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "UCHealth Highlands Ranch Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1500 Park Central Dr, Highlands Ranch, CO 80129, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-291c-75ea-ab6c-4b1aecaf92a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-291c-75ea-ab6c-4b1aecaf92a0",
        "storage_key": "property/6767906449166795/019d02d0-291c-75ea-ab6c-4b1aecaf92a0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.uchealth.org/locations/uchealth-highlands-ranch-hospital/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12076574744773727897&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "uchealth-highlands-ranch-hospital",
      "poi_latitude": "39.5520463",
      "poi_longitude": "-105.0054225",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 720-516-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-502e-70f8-aabb-ec082a09fa87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-502e-70f8-aabb-ec082a09fa87",
        "storage_key": "property/6767906449166795/019d02d0-502e-70f8-aabb-ec082a09fa87.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJi4BWv5qBbIcRmRax9b6cmKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_f941baf6-73e1-4a75-a307-be4c81f67bf2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "HCA HealthONE Swedish",
      "poi_type": "Health and Wellness",
      "poi_address": "501 E Hampden Ave, Englewood, CO 80113, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-2a88-7599-95d9-7812d6574344.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-2a88-7599-95d9-7812d6574344",
        "storage_key": "property/6767906449166795/019d02d0-2a88-7599-95d9-7812d6574344.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.healthonecares.com/locations/swedish?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=11855944775002216283&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hca-healthone-swedish",
      "poi_latitude": "39.6538817",
      "poi_longitude": "-104.980537",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 303-788-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-502e-70f8-aabb-ec082a09fa87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-502e-70f8-aabb-ec082a09fa87",
        "storage_key": "property/6767906449166795/019d02d0-502e-70f8-aabb-ec082a09fa87.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJyd6eR4GAbIcRW9enFvXGiKQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_e81baaf1-9184-4f6f-bb9a-f84ebbaf5249",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "Chatfield State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11500 N Roxborough Park Rd, Littleton, CO 80125, USA",
      "poi_short_description": "Biking, hiking, camping & boating with scenic views of the foothills & Platte River Valley.",
      "poi_long_description": "People say this state park offers a variety of activities, including hiking, biking, boating, fishing, and camping. They highlight the beautiful scenery, with lakes, trails, and wildlife, and the spacious campsites. They also like the clean facilities and the off-leash dog park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-993a-7226-9500-98aa5a79a3c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-993a-7226-9500-98aa5a79a3c4",
        "storage_key": "property/6767906449166795/019d02d0-993a-7226-9500-98aa5a79a3c4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://cpw.state.co.us/placestogo/parks/Chatfield",
      "poi_directions_map_url": "https://maps.google.com/?cid=16247156712885067430&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chatfield-state-park",
      "poi_latitude": "39.543065",
      "poi_longitude": "-105.064824",
      "poi_miles_from_property": "12.1",
      "poi_walking_minutes": "4 hours 27 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 303-791-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-50d3-76ad-9da4-ec5febec210c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-50d3-76ad-9da4-ec5febec210c",
        "storage_key": "property/6767906449166795/019d02d0-50d3-76ad-9da4-ec5febec210c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJRzsreAp9a4cRph6eAfN-eeE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_6b800aab-f822-4d2e-812a-5800df05ec6e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "Foothills Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3901 S Carr St, Denver, CO 80235, USA",
      "poi_short_description": "Golf complex with an 18-hole championship course, a par-3 course, and an executive course, plus practice areas.",
      "poi_long_description": "People say this public golf course offers three courses, a par 3, an executive 9, and a championship 18, as well as a driving range with lights for late summer swings. They also highlight the new clubhouse is gorgeous and the staff is generally pleasant.\n\nOther reviews mention the course condition can be poor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-9988-77cc-912f-2dbe8e300623.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-9988-77cc-912f-2dbe8e300623",
        "storage_key": "property/6767906449166795/019d02d0-9988-77cc-912f-2dbe8e300623.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.foothillsgolf.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14387361458310124197&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "foothills-golf-course",
      "poi_latitude": "39.6455843",
      "poi_longitude": "-105.0918799",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 303-409-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-54fd-73d4-84a1-9471086e22f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-54fd-73d4-84a1-9471086e22f3",
        "storage_key": "property/6767906449166795/019d02d0-54fd-73d4-84a1-9471086e22f3.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJVRJ_29iBa4cRpZK40QQtqsc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_33c59a9b-00db-422d-83ca-04396639e073",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "Robert F. Clement Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7306 W Bowles Ave, Littleton, CO 80123, USA",
      "poi_short_description": "Suburban park with a 60-acre lake offering sport courts, games, picnic areas & playgrounds.",
      "poi_long_description": "People say this park offers a beautiful lake for walking, a large playground, a splash pad, and various sports areas, including tennis and pickleball courts. They highlight the park's well-maintained condition, scenic views, and safe, family-friendly atmosphere. They also like the ample parking, picnic areas, and pavilions available for rent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-9b21-735b-ac64-d8997cdf623a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-9b21-735b-ac64-d8997cdf623a",
        "storage_key": "property/6767906449166795/019d02d0-9b21-735b-ac64-d8997cdf623a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ifoothills.org/clement-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3501848724358870082&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "robert-f-clement-park",
      "poi_latitude": "39.60645460000001",
      "poi_longitude": "-105.0791129",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 303-409-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-50d3-76ad-9da4-ec5febec210c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-50d3-76ad-9da4-ec5febec210c",
        "storage_key": "property/6767906449166795/019d02d0-50d3-76ad-9da4-ec5febec210c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJk4E8CwB_a4cRQrSQeNwQmTA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_22184f5a-48df-45ed-86bb-89b505f6764f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "Cornerstone Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5150 S Windermere St, Littleton, CO 80120, USA",
      "poi_short_description": "Community spot with sports fields, mini-golf, an inline skating rink, a 1-mile trail & playgrounds.",
      "poi_long_description": "People say this park offers a wide variety of amenities, including soccer fields, baseball fields, batting cages, pickleball courts, a skatepark, a splash pad, and playgrounds. They highlight the park is clean, lively, and spacious, with scenic mountain views and ample parking. They also like the paved trails for walking and biking, and the variable-speed batting cages. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-9b8c-75e1-8d34-d88891031cbf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-9b8c-75e1-8d34-d88891031cbf",
        "storage_key": "property/6767906449166795/019d02d0-9b8c-75e1-8d34-d88891031cbf.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.ssprd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11009065199990600825&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cornerstone-park",
      "poi_latitude": "39.6233478",
      "poi_longitude": "-105.0057409",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 303-953-7625",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-50d3-76ad-9da4-ec5febec210c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-50d3-76ad-9da4-ec5febec210c",
        "storage_key": "property/6767906449166795/019d02d0-50d3-76ad-9da4-ec5febec210c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJHecBLEmAbIcRefSNingOyJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e47a2f81-52c2-4d9e-8f75-451eeeef144e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "Overland Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1801 S Huron St, Denver, CO 80223, USA",
      "poi_short_description": "Mountain view 18-hole golf course offering practice facilities, a driving range & pro shop.",
      "poi_long_description": "Mountain view 18-hole golf course offering practice facilities, a driving range & pro shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-9fe3-701a-a632-26f2b2b00aa5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-9fe3-701a-a632-26f2b2b00aa5",
        "storage_key": "property/6767906449166795/019d02d0-9fe3-701a-a632-26f2b2b00aa5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.cityofdenvergolf.com/overland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9739627112157121520&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "overland-golf-course",
      "poi_latitude": "39.6830284",
      "poi_longitude": "-104.9975219",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 720-865-0430",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-54fd-73d4-84a1-9471086e22f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-54fd-73d4-84a1-9471086e22f3",
        "storage_key": "property/6767906449166795/019d02d0-54fd-73d4-84a1-9471086e22f3.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJC7nzC7p_bIcR8IvjeEEbKoc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_7643117b-227b-4625-be2a-970dd9aacf07",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "I-25 & Broadway Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "901 S Broadway, Denver, CO 80209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-a0e7-733e-9323-b55a5411f710.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-a0e7-733e-9323-b55a5411f710",
        "storage_key": "property/6767906449166795/019d02d0-a0e7-733e-9323-b55a5411f710.webp",
        "width": 1280,
        "height": 735
      },
      "poi_business_url": "https://www.rtd-denver.com/i-25-broadway-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=6379514736439613215&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "i-25--broadway-station",
      "poi_latitude": "39.7015719",
      "poi_longitude": "-104.9900036",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-4ffa-7341-a65c-c8872a04171b",
        "storage_key": "property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuai2QQF_bIcRH1faSNqWiFg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_1241098c-6da1-41f9-ac99-6ca2f63adf5b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "Littleton / Mineral Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Littleton, CO 80120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-a18a-75cf-b7e5-bb0712a07a06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-a18a-75cf-b7e5-bb0712a07a06",
        "storage_key": "property/6767906449166795/019d02d0-a18a-75cf-b7e5-bb0712a07a06.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.rtd-denver.com/littleton-mineral-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=17891329290712150304&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "littleton--mineral-station",
      "poi_latitude": "39.5801167",
      "poi_longitude": "-105.0249298",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 303-299-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-4ffa-7341-a65c-c8872a04171b",
        "storage_key": "property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqRz4XfuBbIcRIHFwlDLFSvg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_b4a01ce3-1da9-42fd-964a-4d14f4e81b82",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "Belleview Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Denver, CO 80237, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-a194-737c-9042-8263ecdc104f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-a194-737c-9042-8263ecdc104f",
        "storage_key": "property/6767906449166795/019d02d0-a194-737c-9042-8263ecdc104f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rtd-denver.com/belleview-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=411848644852892074&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "belleview-station",
      "poi_latitude": "39.6276318",
      "poi_longitude": "-104.9044568",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 303-299-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-4ffa-7341-a65c-c8872a04171b",
        "storage_key": "property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc2LMpeKGbIcRqsGuESkutwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_cd1321d7-2539-4d0e-9986-747730b363a5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "University of Denver Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Denver, CO 80210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-384f-7607-b184-cd6ce0630db5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-384f-7607-b184-cd6ce0630db5",
        "storage_key": "property/6767906449166795/019d02d0-384f-7607-b184-cd6ce0630db5.webp",
        "width": 1280,
        "height": 1031
      },
      "poi_business_url": "http://www.rtd-denver.com/university-of-denver-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=11512250056939767551&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-denver-station",
      "poi_latitude": "39.6852869",
      "poi_longitude": "-104.9648189",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 303-299-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-4ffa-7341-a65c-c8872a04171b",
        "storage_key": "property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG8YPm0F-bIcR_4ZdqW66w58",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_5332ef54-c6d5-4dbc-91fa-77fdd95c5204",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "Colorado Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Denver, CO 80222, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-3a23-739a-9016-006cc755aab7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-3a23-739a-9016-006cc755aab7",
        "storage_key": "property/6767906449166795/019d02d0-3a23-739a-9016-006cc755aab7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.rtd-denver.com/colorado-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=17246695069036725807&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "colorado-station",
      "poi_latitude": "39.67950099999999",
      "poi_longitude": "-104.93779",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 303-299-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-4ffa-7341-a65c-c8872a04171b",
        "storage_key": "property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNe5x9OF9bIcRL0Zq08mRWO8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_ae0dac0a-e81c-4277-b455-ca42e9e7937d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "Visa",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8910 Ridgeline Blvd, Highlands Ranch, CO 80129, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-3dd0-7316-b8ae-e5ad1a514658.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-3dd0-7316-b8ae-e5ad1a514658",
        "storage_key": "property/6767906449166795/019d02d0-3dd0-7316-b8ae-e5ad1a514658.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4786705285699685289&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "visa",
      "poi_latitude": "39.5535654",
      "poi_longitude": "-104.9946379",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-4ffa-7341-a65c-c8872a04171b",
        "storage_key": "property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQf3V182DbIcRqUudphjLbUI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_2ed4815f-5e82-49d5-99d7-6b60b8bf36fe",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "Newmont Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6900 E Layton Ave #700, Denver, CO 80237, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-3f94-77aa-bbcd-da20a4e7362d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-3f94-77aa-bbcd-da20a4e7362d",
        "storage_key": "property/6767906449166795/019d02d0-3f94-77aa-bbcd-da20a4e7362d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.newmont.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8685057028189691728&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "newmont-corporation",
      "poi_latitude": "39.626791",
      "poi_longitude": "-104.9061788",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 303-863-7414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-4ffa-7341-a65c-c8872a04171b",
        "storage_key": "property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpWMK7GKGbIcRUJ9BC1qFh3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_54816ad8-959f-4a4a-9e40-a15459f99fda",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "Air Methods",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5500 S Quebec St #100, Greenwood Village, CO 80111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-3ef8-71b9-bdea-5a6604fdf3b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-3ef8-71b9-bdea-5a6604fdf3b2",
        "storage_key": "property/6767906449166795/019d02d0-3ef8-71b9-bdea-5a6604fdf3b2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.airmethods.com/about-us",
      "poi_directions_map_url": "https://maps.google.com/?cid=8162509213580998864&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "air-methods",
      "poi_latitude": "39.6159086",
      "poi_longitude": "-104.902851",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 303-792-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-4ffa-7341-a65c-c8872a04171b",
        "storage_key": "property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZeDkYrqHbIcR0DhZB-IOR3E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_d44514c4-67d7-4c14-bdaa-c32d352f49d2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "UDR",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1745 Shea Center Dr #200, Highlands Ranch, CO 80129, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-aa39-724a-be98-4190b5589787.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-aa39-724a-be98-4190b5589787",
        "storage_key": "property/6767906449166795/019d02d0-aa39-724a-be98-4190b5589787.webp",
        "width": 900,
        "height": 479
      },
      "poi_business_url": "http://www.udr.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17444962109515007430&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "udr",
      "poi_latitude": "39.5551918",
      "poi_longitude": "-105.0089208",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-4ffa-7341-a65c-c8872a04171b",
        "storage_key": "property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ16m4XxWCbIcRxoXKeZz0GPI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_73c7dc97-ef5f-43a2-b5e6-eaadebc27d90",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "poi_name": "HCA HealthONE Division",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4900 S Monaco St, Denver, CO 80237, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://healthonecares.com/?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=14348739412368783164&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hca-healthone-division",
      "poi_latitude": "39.6260444",
      "poi_longitude": "-104.9108076",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 303-788-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-4ffa-7341-a65c-c8872a04171b",
        "storage_key": "property/6767906449166795/019d02d0-4ffa-7341-a65c-c8872a04171b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3equFx6HbIcRPHfjAHn2IMc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_d3f8a19c-1c61-40a0-b82b-12573136e688",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "day": "MON",
      "open_time": "08:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_f48f94a5-5ee4-4ad5-b4e3-8f634b9e293e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "day": "TUE",
      "open_time": "08:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_0ebf4efd-9f88-4e7d-87ed-ceb5e0e4b0b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "day": "WED",
      "open_time": "08:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_9d19058c-515c-445c-8aa9-b2301c3b307d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "day": "THU",
      "open_time": "08:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_9cb2860b-09e6-4f7f-a98a-e466613f2e48",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "day": "FRI",
      "open_time": "08:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_a866057e-04e9-484a-b6ac-114bdbfd830e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "rating": "5.0",
      "name": "Sandra G Carranza",
      "text": "I was stopping by to thank Ashley for her excellent service and professionalism. I also want to thank Mike for his excellent maintenance work. I really appreciate his service-minded attitude; he's a really hard worker.",
      "date": "2025-04-30",
      "title": ""
    },
    {
      "id": "custom_87b78c26-699c-4b2b-8c84-0f930ba64366",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "rating": "5.0",
      "name": "Zharia Chanelle",
      "text": "Beautiful property in a cute, easy-to-access community! Maddie and Mike are truly holding down the fort.",
      "date": "2025-10-03",
      "title": ""
    },
    {
      "id": "custom_e35541f0-b183-4b5f-a311-187e4bc0834e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "rating": "5.0",
      "name": "Sean Bauer",
      "text": "Having stayed here for more than a year now, and with active maintenance and renovations happening across the complex, it has been nothing but a perfect and pleasant experience getting to live here. Ashley's been lovely to work with, supper attentive to anything going on, and more than helpful to anything we've needed. So happy and content to get to live here.",
      "date": "2024-11-08",
      "title": ""
    },
    {
      "id": "custom_3176cff7-a9a0-4c99-a562-80baf2f77793",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "rating": "5.0",
      "name": "Salem Price",
      "text": "Coming from out-of-state, Ashley was instrumental in helping me find the perfect unit and getting me set-up for move in! The location cannot be beaten, appliances and upgrades in the unit are wonderful, and maintenance is always responsive. I moved-in sight unseen, and nothing has disappointed. I really enjoy living here and have had nothing but great experiences.",
      "date": "2024-02-09",
      "title": ""
    },
    {
      "id": "custom_fc294d6b-435b-4c0a-aa30-fb3893094ffc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "rating": "5.0",
      "name": "Rob Evans",
      "text": "We really enjoyed living at the station.  The location is amazing, and the apartment we rented was clean with brand new appliances.  While the location and apartment were great I think it was Jackie and Mike (maintenance) who make this place what it is.  They're quick to respond to issues and on top of it just really nice people in general and a pleasure to deal with.  I would highly recommend renting here.",
      "date": "2023-05-02",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_1a880509-ffcb-4a41-ab46-a265280f15b6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166795/019faa56-9a82-728b-82d5-ec7899c268ec.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019faa56-9a82-728b-82d5-ec7899c268ec",
        "storage_key": "property/6767906449166795/019faa56-9a82-728b-82d5-ec7899c268ec.webp",
        "width": 2048,
        "height": 2048
      },
      "virtual_tour_title": "3D Walking Tour",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://3dplans.com/apps/hosting/29833/"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019fa8f9-1532-75ea-9793-df50b9e099f7",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "The Station Website",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-littleton-co-station",
      "search_query": "in unit laundry apartments Littleton CO",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Littleton, CO",
      "h2_subtitle": "Discover modern living with in-unit laundry at Station. Located in Downtown Littleton, our apartments offer convenience and style.",
      "page_copy": "Looking for in-unit laundry apartments in Littleton, CO? Station introduces you to contemporary urban living with all the comforts you desire. Situated at the heart of Downtown Littleton, our community provides a seamless blend of convenience and charm, making it the ideal spot to call home.\n\nExperience the luxury of in-unit laundry along with state-of-the-art amenities like stainless steel appliances, ample storage space, and much more. Just a short stroll from campus, Station is perfect for those seeking a vibrant neighborhood atmosphere with quick access to everything Littleton has to offer. Enjoy a relaxing lifestyle and the practical benefits of modern apartment living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in Littleton, CO",
      "seo_description": "Find in-unit laundry apartments at Station in Littleton, CO. Enjoy modern amenities in the heart of Downtown Littleton.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-downtown-littleton-station",
      "search_query": "air conditioned apartments downtown Littleton",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments Downtown Littleton",
      "h2_subtitle": "Stay cool in the heart of Downtown Littleton with our air-conditioned apartments. Station offers a comfortable, modern lifestyle you will love.",
      "page_copy": "If you're in search of air-conditioned apartments in Downtown Littleton, look no further than Station. Perfectly located, our community combines the excitement of urban living with a tranquil atmosphere. At Station, we prioritize your comfort and provide an ideal living environment for all seasons.\n\nBeyond air conditioning, enjoy premium amenities that include stainless steel appliances, storage spaces, and more. Station makes living easy, placing you close to local attractions and conveniences while ensuring a peaceful retreat at the end of the day. Dive into a lifestyle that meets all your needs right in lively Downtown Littleton.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments Downtown Littleton",
      "seo_description": "Stay comfortable at Station in Downtown Littleton with air-conditioned apartments and modern amenities. Discover urban living with ease.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "generator",
      "page_item_url": "apartments-with-dishwasher-arapahoe-county-station",
      "search_query": "apartments with dishwasher Arapahoe County",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher in Arapahoe County",
      "h2_subtitle": "Discover convenience in Arapahoe County at Station, featuring apartments with modern dishwashers and more. Experience ease and comfort in your new home.",
      "page_copy": "Searching for apartments with a dishwasher in Arapahoe County? Station Apartments offer a superb living experience with all the modern conveniences you need. Located in the vibrant Downtown Littleton area, our community provides easy access to everything this charming locale has to offer.\n\nIn addition to dishwashers, our units feature stainless steel appliances, plenty of storage space, and a tub/shower setup to enhance your daily routine. Whether you're relaxing at home or exploring the neighborhood, Station provides the perfect blend of comfort and practicality in Arapahoe County. Live in style and convenience at Station.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwasher in Arapahoe County",
      "seo_description": "Discover Station Apartments in Arapahoe County with dishwashers and modern amenities. Enjoy a practical and stylish lifestyle in Downtown Littleton.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "generator",
      "page_item_url": "walk-in-closets-apartments-near-littleton-station",
      "search_query": "walk-in closets apartments near Littleton",
      "category": "Amenity",
      "h1_title": "Walk-In Closets Apartments Near Littleton",
      "h2_subtitle": "Enjoy ample storage with walk-in closets at Station near Littleton. Our stylish apartments offer the perfect blend of comfort and convenience.",
      "page_copy": "For those seeking walk-in closets in apartments near Littleton, Station offers a perfect blend of style and functionality. Nestled in Downtown Littleton, our community provides easy access to local amenities while delivering exceptional in-home comforts.\n\nOur spacious apartments feature not only walk-in closets but also stainless steel appliances, in-unit laundry options, and more. Positioned conveniently near campus, Station is a superb choice for those wanting a practical, upscale living environment. Experience the advantage of having abundant storage and a beautifully designed home at Station, close to all Littleton has to offer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Walk-In Closets Apartments Near Littleton",
      "seo_description": "Find spacious apartments with walk-in closets at Station near Littleton. Enjoy modern living with ample storage and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "generator",
      "page_item_url": "high-speed-internet-arapahoe-county-apartments-station",
      "search_query": "high speed internet Arapahoe County apartments",
      "category": "Amenity",
      "h1_title": "High Speed Internet Arapahoe County Apartments",
      "h2_subtitle": "Stay connected with high speed internet at Station Apartments in Arapahoe County. Enjoy seamless tech and modern amenities in an unmatched location.",
      "page_copy": "Looking for Arapahoe County apartments with high speed internet? Station Apartments offer the perfect solution for all your connectivity needs. Nestled in Downtown Littleton, Station ensures a seamless experience whether you're working from home or streaming your favorite shows.\n\nIn addition to fast internet, our apartments feature modern amenities, including stainless steel appliances and generous storage spaces. Situated in a prime location, Station provides the perfect balance of accessibility and comfort. Dive into a tech-friendly lifestyle at Station, where high-speed connectivity meets exquisite living in Arapahoe County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "High Speed Internet Arapahoe County Apartments",
      "seo_description": "Enjoy high speed internet at Station Apartments in Arapahoe County. Discover modern living with excellent connectivity and amenities in Littleton.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "generator",
      "page_item_url": "studio-apartments-downtown-littleton-station",
      "search_query": "studio apartments downtown littleton",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Downtown Littleton",
      "h2_subtitle": "Discover the perfect studio apartments at Station in Downtown Littleton. Enjoy modern amenities and a vibrant lifestyle right at your doorstep.",
      "page_copy": "Searching for studio apartments in Downtown Littleton? Station offers exceptionally designed studio units in the heart of this charming neighborhood. Experience a vibrant lifestyle with access to local dining, shopping, and entertainment just steps away from your front door.\n\nOur studios at Station come equipped with stainless steel appliances and storage options, ensuring a comfortable and convenient living experience. With modern features like a tub/shower combination and the ability to walk to nearby campus, Station is the ideal choice for those seeking a dynamic and practical living environment in Downtown Littleton.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Downtown Littleton",
      "seo_description": "Explore studio apartments at Station in Downtown Littleton. Enjoy modern amenities and vibrant urban living in the heart of the city.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-littleton-co-station",
      "search_query": "1 bedroom apartments littleton co",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Littleton, CO",
      "h2_subtitle": "Explore spacious 1 bedroom apartments at Station in Littleton, CO. Discover a blend of modern amenities and a prime location in Arapahoe County.",
      "page_copy": "If you're on the hunt for 1 bedroom apartments in Littleton, CO, Station is your ideal choice. This community offers a harmonious balance of comfort and urban living, situated in the heart of Downtown Littleton. Each unit is designed with modern conveniences in mind, including stainless steel appliances and ample storage space.\n\nStation ensures convenience with features like walking distance to the local campus and easy access to public transportation. Enjoy a vibrant community atmosphere while relishing the peace and privacy of your one-bedroom sanctuary. Choose Station for a smart and stylish living option in Littleton, CO.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Littleton, CO",
      "seo_description": "Discover modern 1 bedroom apartments at Station in Littleton, CO. Enjoy comfort and convenience in a prime location near downtown.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166795",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-arapahoe-county-station",
      "search_query": "2 bedroom apartments arapahoe county",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Arapahoe County",
      "h2_subtitle": "Explore spacious 2 bedroom apartments at Station in Arapahoe County. Enjoy modern living with top amenities in a vibrant community setting.",
      "page_copy": "Looking for 2 bedroom apartments in Arapahoe County? Station offers the perfect blend of space and comfort. Situated in the bustling area of Downtown Littleton, Station provides an ideal living environment enriched with modern amenities like stainless steel appliances and generous storage solutions.\n\nEach apartment is designed for contemporary living, featuring a cozy tub/shower and a location that allows you to walk to nearby campus. At Station, you get more than just an apartment – you gain access to a vibrant community with all the conveniences of urban living. Experience a prime location poised to meet your lifestyle needs in Littleton's finest neighborhood.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Arapahoe County",
      "seo_description": "Discover spacious 2 bedroom apartments at Station in Arapahoe County. Enjoy modern amenities and a prime Downtown Littleton location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "lindseye@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6028"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10715005299"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WLVD3XH6"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Pathfinder 2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Pathfinder Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "375TSN"
    },
    {
      "ID": "custom_anyonehome_chatbot",
      "type": "STRING",
      "value": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('cVFCShF7XOrQhip5J4')</script>"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "2756511728"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/8xvr5z6mwjk"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "ER100107678"
    },
    {
      "ID": "custom_website_tracking_email",
      "type": "STRING",
      "value": "amcllc_thestation_web_propertywebsite@leads.anyonehome.com"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlhvdW0wYVlBUUE2a25QWjJjc1hGaFE9PSIsInZhbHVlIjoiczg3TVJqZG5jbnBRcVNJcGhxa1ZmQT09IiwibWFjIjoiODBjMTcyZGRiOTIxMDBhNDY3NWQ0YmU4MmM5N2Q2NmNkNTljYTI1MzcxMjdhMTA2N2Q5MGRlZWE2MWQ0NTJlNCJ9"
    }
  ],
  "custom_csm": "lindseye@repli360.com",
  "custom_qb_id": "6028",
  "custom_repli_id": "10715005299",
  "custom_google_gtm_id": "GTM-WLVD3XH6",
  "custom_rollout_phase": "Pathfinder 2",
  "custom_vibesites_theme": "Pathfinder Preferred",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "full_stack",
  "custom_aim_property_code": "375TSN",
  "custom_anyonehome_chatbot": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('cVFCShF7XOrQhip5J4')</script>",
  "custom_hubspot_company_id": "2756511728",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/8xvr5z6mwjk",
  "custom_website_subscription": "turnkey",
  "custom_broker_license_number": "ER100107678",
  "custom_website_tracking_email": "amcllc_thestation_web_propertywebsite@leads.anyonehome.com",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlhvdW0wYVlBUUE2a25QWjJjc1hGaFE9PSIsInZhbHVlIjoiczg3TVJqZG5jbnBRcVNJcGhxa1ZmQT09IiwibWFjIjoiODBjMTcyZGRiOTIxMDBhNDY3NWQ0YmU4MmM5N2Q2NmNkNTljYTI1MzcxMjdhMTA2N2Q5MGRlZWE2MWQ0NTJlNCJ9",
  "custom_audioeye_site_id": "bc08a4ea-365f-41ab-be25-37ba23134837",
  "custom_audioeye_site_hash": "878ad3bf750844bc58933ba9612f66da"
};

export const generatedAt = '2026-10-08T21:19:02.370Z';
